/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './customer-navbar.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../custom-menu/custom-menu.component.ngfactory';
import * as i5 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i6 from '../../../../app/shared/settings.service';
import * as i7 from '../../../../app/auth/current-user';
import * as i8 from '../logged-in-user-widget/logged-in-user-widget.component.ngfactory';
import * as i9 from '../../../../app/shared/logged-in-user-widget/logged-in-user-widget.component';
import * as i10 from '../../../../app/auth/auth.service';
import * as i11 from '../../../../app/shared/customer-navbar/customer-navbar.component';
const styles_CustomerNavbarComponent:any[] = [i0.styles];
export const RenderType_CustomerNavbarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomerNavbarComponent,data:{}});
function View_CustomerNavbarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'Logo'],['class','logo']],[[8,'src',4]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.settings.get('branding.hc_logo');
    _ck(_v,0,0,currVal_0);
  });
}
function View_CustomerNavbarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'text-logo']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.settings.get('branding.site_name');
    _ck(_v,1,0,currVal_0);
  });
}
export function View_CustomerNavbarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'nav',[['class',
      'navbar']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'div',[['class','nav-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'a',[['class','nav-group logo-group left'],
          ['routerLink','/']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerNavbarComponent_1)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomerNavbarComponent_2)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'custom-menu',[['class','nav-group right'],['position','header']],
          [[2,'hidden',(null as any)]],(null as any),(null as any),i4.View_CustomMenuComponent_0,
          i4.RenderType_CustomMenuComponent)),i1.ɵdid(245760,(null as any),0,i5.CustomMenuComponent,
          [i6.SettingsService,i7.CurrentUser],{position:[0,'position']},(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,1,'logged-in-user-widget',
          [['class','nav-item']],(null as any),(null as any),(null as any),i8.View_LoggedInUserWidgetComponent_0,
          i8.RenderType_LoggedInUserWidgetComponent)),i1.ɵdid(49152,(null as any),
          0,i9.LoggedInUserWidgetComponent,[i7.CurrentUser,i10.AuthService],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i11.CustomerNavbarComponent = _v.component;
    const currVal_2:any = '/';
    _ck(_v,5,0,currVal_2);
    const currVal_3:any = _co.settings.has('branding.hc_logo');
    _ck(_v,8,0,currVal_3);
    const currVal_4:boolean = !_co.settings.has('branding.hc_logo');
    _ck(_v,11,0,currVal_4);
    const currVal_6:any = 'header';
    _ck(_v,15,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).target;
    const currVal_1:any = i1.ɵnov(_v,5).href;
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_5:any = i1.ɵnov(_v,15).shouldHide;
    _ck(_v,14,0,currVal_5);
  });
}
export function View_CustomerNavbarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'customer-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),View_CustomerNavbarComponent_0,
      RenderType_CustomerNavbarComponent)),i1.ɵdid(49152,(null as any),0,i11.CustomerNavbarComponent,
      [i7.CurrentUser,i6.SettingsService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const CustomerNavbarComponentNgFactory:i1.ComponentFactory<i11.CustomerNavbarComponent> = i1.ɵccf('customer-navbar',
    i11.CustomerNavbarComponent,View_CustomerNavbarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/customer-navbar/customer-navbar.component.ngfactory.ts